module.exports = __webpack_public_path__ + "static/media/medpro-blue.cc864569.svg";